import React from 'react';

export default function Panel({ title, right, empty, emptyText, children }) {
  return (
    <div style={{
      background: 'white', borderRadius: 12, padding: 24, marginBottom: 24,
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        marginBottom: 20,
      }}>
        <h3 style={{ margin: 0 }}>{title}</h3>
        {right}
      </div>
      {empty
        ? <div style={{ textAlign: 'center', color: '#6b7280', padding: 40 }}>{emptyText}</div>
        : children}
    </div>
  );
}
